// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reportPage__I2gKm {
  overflow-y: auto;
  height: 100%;
}

.reportPageBody__ZmV30 {
  padding: 25px 0 0 25px;
  background: var(--tables-main-surface);
}

.reportPageList__njrf5 {
  display: flex;
  flex-wrap: wrap;
  margin: -25px 0 0 -25px;
  width: 100%;
}

.reportPageReport__HDoZJ {
  max-width: 100%;
  width: 100%;
  padding: 25px 0 0 25px;
  margin: 0;
}
@media (min-width: 900px) {
  .reportPageReport__HDoZJ {
    flex-basis: 50%;
    max-width: 50%;
  }
}
@media (min-width: 1200px) {
  .reportPageReport__HDoZJ {
    flex-basis: 25%;
    max-width: 25%;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/Reports/style.module.scss"],"names":[],"mappings":"AA4EA;EACE,gBAAA;EACA,YAAA;AA3EF;;AA8EA;EACE,sBAAA;EACA,sCAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;AA3EF;AA6EE;EANF;IAOI,eAAA;IACA,cAAA;EA1EF;AACF;AA2EE;EAVF;IAWI,eAAA;IACA,cAAA;EAxEF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.reportPage {\n  overflow-y: auto;\n  height: 100%;\n}\n\n.reportPageBody {\n  padding: 25px 0 0 25px;\n  background: var(--tables-main-surface);\n}\n\n.reportPageList {\n  display: flex;\n  flex-wrap: wrap;\n  margin: -25px 0 0 -25px;\n  width: 100%;\n}\n\n.reportPageReport {\n  max-width: 100%;\n  width: 100%;\n  padding: 25px 0 0 25px;\n  margin: 0;\n\n  @media (min-width: 900px) {\n    flex-basis: 50%;\n    max-width: 50%;\n  }\n  @media (min-width: 1200px) {\n    flex-basis: 25%;\n    max-width: 25%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reportPage": `reportPage__I2gKm`,
	"reportPageBody": `reportPageBody__ZmV30`,
	"reportPageList": `reportPageList__njrf5`,
	"reportPageReport": `reportPageReport__HDoZJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
